import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from './shared.module';


@NgModule({
    imports: [
        BrowserModule,       
        CommonModule,
        FormsModule, ReactiveFormsModule,
        SharedModule
    ],
    declarations: [
        
    ],
    providers: [          
         // DOABrowserModule
    ]

})

export class UpplmModuleShared {
    ngOnInit() { /* empty */}
}
